export const SET_BULK_EDIT_DATA = 'SET_BULK_EDIT_DATA';
export const SET_SINGLE_SELECTED_ID = 'SET_SINGLE_SELECTED_ID';
export const REMOVE_SELECTED_IDS_PER_PAGE = 'REMOVE_SELECTED_IDS_PER_PAGE';
export const SELECT_ALL_IDS_PER_PAGE = 'SELECT_ALL_IDS_PER_PAGE';

export const setBulkEditData = (formKey, newData) => ({
  type: SET_BULK_EDIT_DATA,
  formKey,
  payload: { newData },
});

export const setSingleSelectedId = (formKey, selectedId) => ({
  type: SET_SINGLE_SELECTED_ID,
  formKey,
  payload: { selectedId },
});

export const removeSelectedIdsPerPage = (formKey, allRowsPerPage) => ({
  type: REMOVE_SELECTED_IDS_PER_PAGE,
  formKey,
  payload: { allRowsPerPage },
});

export const selectAllIdsPerPage = (formKey, allRowsPerPage) => ({
  type: SELECT_ALL_IDS_PER_PAGE,
  formKey,
  payload: { allRowsPerPage },
});
